import { DownloadOutlined } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    code: string;
    name: string;
    useIcon?: boolean;
    variant?: 'text' | 'outlined' | 'contained';
}

export const DownloadCard: FC<Props> = ({ code, name, useIcon = false, variant = 'text' }) => {
    const { t } = useTranslation();
    const href = `/logistics-api/cards/${code}?name=${name}`;

    return useIcon ? (
        <IconButton href={href} target="_blank" onClick={(e) => e.stopPropagation()}>
            <DownloadOutlined />
        </IconButton>
    ) : (
        <Button variant={variant} color="secondary" href={href} target="_blank" onClick={(e) => e.stopPropagation()}>
            {t('download')}
        </Button>
    );
};
